import { createRouter, createWebHashHistory } from 'vue-router'
import AuthLayout from '@/layouts/Auth'
import DefaultLayout from '@/layouts/DefaultLayout.vue'

const routes = [
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'Login',
        component: AuthLayout,
        meta: {
          title: 'LOGIN',
        },
      },
    ],
  },

  {
    path: '/campanhas',
    name: 'Campanhas',
    redirect: '/campanhas',
    component: DefaultLayout,
    children: [
      {
        path: '/campanhas',
        name: 'Campanhas',
        component: () => import('@/views/modulo_campanhas/campanha/List.vue'),
      },
      {
        path: '/campanha',
        name: 'Nova Campanha',
        meta: {},
        component: () => import('@/views/modulo_campanhas/campanha/Form.vue'),
      },
      {
        path: '/campanha/:id',
        name: 'Alteração Campanha',
        meta: {},
        component: () => import('@/views/modulo_campanhas/campanha/Form.vue'),
      },
      {
        path: '/pedidos/:id',
        name: 'Lista Pedidos Campanha',
        meta: {},
        component: () => import('@/views/modulo_campanhas/pedido/List.vue'),
      },
      {
        path: '/pedido',
        name: 'Novo Pedido',
        meta: {},
        component: () => import('@/views/modulo_campanhas/pedido/Form.vue'),
      },
      {
        path: '/pedido/:id',
        name: 'Alteração Pedido',
        meta: {},
        component: () => import('@/views/modulo_campanhas/pedido/Form.vue'),
      },
      {
        path: '/distribuidores',
        name: 'Distribuidores',
        meta: {},
        component: () =>
          import('@/views/modulo_campanhas/distribuidor/List.vue'),
      },
      {
        path: '/condpgtos',
        name: 'Condições de Pagamento',
        meta: {},
        component: () => import('@/views/modulo_campanhas/cond_pgto/List.vue'),
      },
    ],
  },

  {
    path: '/manutencao',
    name: 'Manutencao',
    component: () => import('@/views/modulo_campanhas/Manutencao.vue'),
  },
  {
    path: '/pedido-farmacias/:id/:farmacia_matriz_id',
    name: 'Lista de Pedidos de Filiais',
    meta: {},
    component: () => import('@/views/modulo_campanhas/pedido/List.vue'),
  },
  {
    path: '/pedido-form',
    name: 'Pedido Form',
    meta: {},
    component: () => import('@/views/modulo_campanhas/pedido/Form.vue'),
  },
  {
    path: '/historico-pedidos/:farmacia_matriz_id',
    name: 'Historico de Pedidos',
    meta: {},
    component: () => import('@/views/modulo_campanhas/pedido/Historico.vue'),
  },
  {
    path: '/associar-farmacias/:campanha_id',
    name: 'Associar Farmácias',
    meta: {},
    component: () =>
      import('@/views/modulo_campanhas/campanha/mais_pedidos/Form.vue'),
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior() {
    return { top: 0 }
  },
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/register', '/home']
  const authRequired = !publicPages.includes(to.path)
  const loggedIn = localStorage.getItem('token')
  // trying to access a restricted page + not logged in
  // redirect to login page
  if (authRequired && !loggedIn) {
    next('/login')
  } else {
    next()
  }
})

export default router
